import React, { useRef, useEffect, useContext, useState } from "react";
import { Col, Container, Row, Form, Button, Spinner } from "react-bootstrap";
import { generateStars } from "../../DisconnectedWallet/components/styles";
import styles from "../../DisconnectedWallet/components/index.module.css";
import lottieJson from "../../../assets/lottie/hero.json";
import G1 from "../../../assets/trt/1.png";
import G2 from "../../../assets/trt/2.png";
import G3 from "../../../assets/trt/3.png";
import G4 from "../../../assets/trt/4.png";
import Lottie from "react-lottie-player";
import { AppContext } from "../../../scripts/context";
import "./style.css";
import toast from "react-hot-toast";
import { request } from "../../../admin/plugins/axios";
import { endpoints } from "../../../utils/networks";

/*  This Component view when connect to wallet but not signatur to messase from metamask ,  (connect but not have token) | khaled Mofeed */
function Index({ openAccountModal, account }) {
  const {
    disconnect,
    requiresProfileCompletion,
    setRequiresProfileCompletion,
    setIsToken,
    getWeb3,
    setLoading,
    userData,
    setUserData,
    initState,
    setState,
  } = useContext(AppContext) || {};

  const [form, setForm] = useState({
    name: "",
    email: "",
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  /*  This useEffect use for check if no account connect make disconnect | khaled Mofeed */
  useEffect(() => {
    if (!account) {
      disconnect();
      setRequiresProfileCompletion(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account]);

  const starContainerRef = useRef(null);

  useEffect(() => {
    if (starContainerRef.current) {
      const removeStars = generateStars(
        starContainerRef.current,
        120,
        100,
        true
      );
      return () => {
        removeStars?.();
      };
    }
  }, []);

  useEffect(() => {
    if (requiresProfileCompletion) {
      setErrors({});
      setForm({
        name: userData?.name || "",
        email: userData?.email || "",
      });
    } else {
      setForm({ name: "", email: "" });
    }
  }, [requiresProfileCompletion, userData]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const validate = () => {
    const validationErrors = {};
    if (!form.name.trim()) {
      validationErrors.name = "Name is required";
    }
    if (!form.email.trim()) {
      validationErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(form.email.trim())) {
      validationErrors.email = "Please enter a valid email";
    }
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validate()) return;

    const storedToken = localStorage.getItem("UserToken");
    console.log("✏️ [UPDATE_PROFILE] Starting profile update:", {
      name: form.name.trim(),
      email: form.email.trim(),
      hasToken: Boolean(storedToken),
      token: storedToken ? storedToken.substring(0, 20) + "..." : "No token",
    });

    setSubmitting(true);
    setLoading?.(true);
    try {
      console.log("✏️ [UPDATE_PROFILE] Sending update request with token:", {
        token: storedToken ? storedToken.substring(0, 20) + "..." : "No token",
      });
      await request(
        endpoints.ProfileData.UpdateProfile.method,
        endpoints.ProfileData.UpdateProfile.url,
        {
          name: form.name.trim(),
          email: form.email.trim(),
        }
      );

      console.log("✏️ [UPDATE_PROFILE] ✅ Update request successful, fetching updated profile...");

      try {
        const profileResponse = await request(
          endpoints.ProfileData.GetProfileData.method,
          endpoints.ProfileData.GetProfileData.url
        );
        const profileUser = profileResponse.data?.data?.user;
        const hasEmail = Boolean(profileUser?.email?.trim());

        console.log("✏️ [UPDATE_PROFILE] Profile data after update:", {
          wallet_address: profileUser?.wallet_address,
          name: profileUser?.name,
          email: profileUser?.email,
          hasEmail: hasEmail,
          token: storedToken ? storedToken.substring(0, 20) + "..." : "No token",
        });

        if (profileUser) {
          const mergedName =
            profileUser.name ||
            `${profileUser.first_name ?? ""} ${
              profileUser.last_name ?? ""
            }`.trim();

          setUserData?.({
            ...profileUser,
            name: mergedName,
          });
          setState?.({
            ...initState,
            user: {
              address: profileUser.wallet_address,
              avatar: profileUser.avatar,
              name: mergedName,
              bio: profileUser.bio,
              cover: profileUser.cover,
              twitter: profileUser.twitter,
              facebook: profileUser.facebook,
              portfolio: profileUser.portfolio,
              linkedin: profileUser.linkedin,
              instagram: profileUser.instagram,
              custom_url: profileUser.custom_url,
              following_count: profileUser.following_count,
              followers_count: profileUser.followers_count,
            },
            loading: false,
          });
        }

        if (hasEmail) {
          console.log("✏️ [UPDATE_PROFILE] ✅ Profile completed successfully:", {
            requiresProfileCompletion: false,
            isToken: true,
            token: storedToken ? storedToken.substring(0, 20) + "..." : "No token",
            email: profileUser?.email,
            name: profileUser?.name,
          });
          await getWeb3?.(account?.address);
          setRequiresProfileCompletion(false);
          setIsToken?.(true);
          toast.success("Profile completed successfully");
        } else {
          console.log("✏️ [UPDATE_PROFILE] ❌ Email still missing:", {
            requiresProfileCompletion: true,
            isToken: false,
            token: storedToken ? storedToken.substring(0, 20) + "..." : "No token",
          });
          setRequiresProfileCompletion(true);
          setIsToken?.(false);
          toast.error("Please add a valid email address to continue");
        }
      } catch (profileError) {
        console.error("❌ [UPDATE_PROFILE] Failed to refresh profile after update:", {
          error: profileError?.response?.data || profileError?.message,
          token: storedToken ? storedToken.substring(0, 20) + "..." : "No token",
        });
        setRequiresProfileCompletion(true);
        setIsToken?.(false);
        toast.error("Unable to verify your profile. Please try again.");
      }
    } catch (error) {
      console.error("❌ [UPDATE_PROFILE] Profile update failed:", {
        error: error?.response?.data || error?.message,
        token: storedToken ? storedToken.substring(0, 20) + "..." : "No token",
      });
      const apiMessage =
        error.response?.data?.message ||
        error.response?.data?.errors?.email?.[0] ||
        error.message;
      toast.error(apiMessage || "Profile update failed");
    } finally {
      setSubmitting(false);
      setLoading?.(false);
    }
  };

  return (
    <Container
      fluid
      className={`px-0 mx-0 ${styles.blur} ${styles.withoutConstantAnimation} ${
        requiresProfileCompletion ? "withformprofile" : ""
      }`}
      style={{ marginTop: "-100px", overflow: "hidden", height: "100vh" }}
    >
      <Row
        ref={starContainerRef}
        className={`text-center justify-content-center mb-mobile-4rem  ${styles.card}`}
      >
        <Col xs={10} md={10} lg={8} xl={6}>
          <div className="under-hero">
            {!requiresProfileCompletion && (
              <>
                <h1 className="bold mb-3">
                  <span className="text-gradient">Waiting For Signature</span>
                </h1>
                <p className="text-white w-140 mob-w-75 mb-4">
                  Please, Sign the message in MetaMask to confirm you own this
                  <br />
                  wallet address. This action will not cost any gas fees.
                </p>
              </>
            )}

            {requiresProfileCompletion && (
              <div className="registration-form-wrapper profile-form-card">
                <h1 className="bold mb-3">
                  <span className="text-gradient">Complete Your Profile</span>
                </h1>
                <p className="text-white w-140 mob-w-75 mb-4">
                  Enter your details to finish creating your account.
                </p>
                <Form
                  onSubmit={handleSubmit}
                  className="text-left profile-grid"
                >
                  <Form.Group className="mb-0" controlId="registration-name">
                    <Form.Control
                      type="text"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      isInvalid={Boolean(errors.name)}
                      placeholder="Enter your name"
                      className="dark-input"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mb-0" controlId="registration-email">
                    <Form.Control
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      isInvalid={Boolean(errors.email)}
                      placeholder="Enter your email address"
                      className="dark-input"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <div className="d-flex justify-content-start align-items-center">
                    <span
                      onClick={openAccountModal}
                      className="text-center withcompleteprofileInform"
                      style={{ cursor: "pointer" }}
                    >
                      <div style={{ position: "relative", zIndex: 99999 }}>
                        <img
                          src="/img/disconnectWhite.svg"
                          alt="disconnect"
                          className="disconnectImg"
                        />{" "}
                        Disconnect
                      </div>
                    </span>
                    {/* <Button
                      variant="outline-light"
                      type="button"
                      onClick={() => {
                        setRequiresProfileCompletion(false);
                        disconnect();
                      }}
                      disabled={submitting}
                    >
                      Cancel
                    </Button> */}
                  </div>
                  <div className="d-flex justify-content-end align-items-center">
                    <Button
                      variant="outline-light"
                      type="submit"
                      disabled={submitting}
                      className="withcompleteprofileContinueButton"
                    >
                      {submitting ? (
                        <>
                          Submitting...
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="ml-2"
                          />
                        </>
                      ) : (
                        "Continue"
                      )}
                    </Button>
                  </div>
                </Form>
              </div>
            )}

            <span
              onClick={openAccountModal}
              className="text-center withcompleteprofile"
              style={{ cursor: "pointer" }}
            >
              <div style={{ position: "relative", zIndex: 99999 }}>
                <img
                  src="/img/disconnectWhite.svg"
                  alt="disconnect"
                  className="disconnectImg"
                />{" "}
                Disconnect
              </div>
            </span>
          </div>
          <Lottie
            className={`lottiePlayer`}
            loop
            animationData={lottieJson}
            play
          />

          <img
            src={G1}
            alt="group1"
            className={`${styles.group1} hero-character hero-character--one`}
          />
          <img
            src={G2}
            alt="group2"
            className={`${styles.group2} hero-character hero-character--two`}
          />
          <img
            src={G3}
            alt="group3"
            className={`${styles.group3} hero-character hero-character--three`}
          />
          <img
            src={G4}
            alt="group4"
            className={`${styles.group4} hero-character hero-character--four`}
          />
        </Col>
      </Row>
    </Container>
  );
}

export default Index;
